<div class="metadata-import-preview">
  <div class="preview-header">
    <h3>Form Metadata Changes</h3>
    <span class="preview-summary" *ngIf="!isLoading && !errorMessage">
      {{ schemaGroups.length }} schema(s) · {{ totalChanges }} change(s)
    </span>
  </div>

  <div *ngIf="isLoading" class="preview-state">Loading…</div>
  <div *ngIf="errorMessage" class="preview-state preview-state--error">{{ errorMessage }}</div>

  <div *ngIf="!isLoading && !errorMessage && !schemaGroups.length" class="preview-state">
    No metadata changes detected across any schema.
  </div>

  <ng-container *ngIf="!isLoading && !errorMessage && schemaGroups.length">
    <section class="schema-group"
             *ngFor="let group of schemaGroups; trackBy: trackBySchemaId">
      <header class="schema-group__header">
        <div class="schema-group__title">
          <span class="schema-group__name">{{ group.title }}</span>
        </div>
        <div class="schema-group__counts">
          <span class="status-chip status-chip--added"
                *ngIf="group.addedCount">+{{ group.addedCount }} added</span>
          <span class="status-chip status-chip--modified"
                *ngIf="group.modifiedCount">~{{ group.modifiedCount }} modified</span>
          <span class="status-chip status-chip--deleted"
                *ngIf="group.deletedCount">−{{ group.deletedCount }} deleted</span>
        </div>
      </header>

      <table mat-table
             [dataSource]="group.changes"
             [trackBy]="group.trackBy"
             class="changes-grid">

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef class="col-status">Status</th>
          <td mat-cell *matCellDef="let row" class="col-status">
            <span class="status-chip"
                  [class.status-chip--added]="row.status === 'Added'"
                  [class.status-chip--modified]="row.status === 'Modified'"
                  [class.status-chip--deleted]="row.status === 'Deleted'">
              {{ row.status }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="key">
          <th mat-header-cell *matHeaderCellDef class="col-key">Field</th>
          <td mat-cell *matCellDef="let row" class="col-key">{{ row.key }}</td>
        </ng-container>

        <ng-container matColumnDef="oldValue">
          <th mat-header-cell *matHeaderCellDef class="col-value">Existing Value</th>
          <td mat-cell *matCellDef="let row" class="col-value">
            <div class="value-preview" *ngIf="row.oldEntries.length; else oldEmpty">
              <div *ngFor="let entry of row.oldEntries" class="value-entry">
                <span *ngIf="entry.subKey" class="value-entry__key">{{ entry.subKey }}:</span>
                <span class="value-entry__value">{{ entry.value }}</span>
              </div>
            </div>
            <ng-template #oldEmpty><span class="value-placeholder">—</span></ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="newValue">
          <th mat-header-cell *matHeaderCellDef class="col-value">New Value</th>
          <td mat-cell *matCellDef="let row" class="col-value">
            <div class="value-preview" *ngIf="row.newEntries.length; else newEmpty">
              <div *ngFor="let entry of row.newEntries" class="value-entry">
                <span *ngIf="entry.subKey" class="value-entry__key">{{ entry.subKey }}:</span>
                <span class="value-entry__value">{{ entry.value }}</span>
              </div>
            </div>
            <ng-template #newEmpty><span class="value-placeholder">—</span></ng-template>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
            *matRowDef="let row; columns: displayedColumns;"
            [class.row-added]="row.status === 'Added'"
            [class.row-modified]="row.status === 'Modified'"
            [class.row-deleted]="row.status === 'Deleted'"></tr>
      </table>
    </section>
  </ng-container>
</div>
